import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.items.length < 1)
      ? _renderSlot(_ctx.$slots, "default", {}, undefined, undefined, 0)
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (i, x) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: x }, [
        (i.text)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(i.text), 1)
            ], 64))
          : (i.html)
            ? (_openBlock(), _createElementBlock("span", {
                key: 1,
                innerHTML: i.html
              }, null, 8, _hoisted_1))
            : (i.widget && _ctx.eventBus)
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(i.widget), {
                  key: 2,
                  modelValue: _ctx.internalModel,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalModel) = $event)),
                  "event-bus": _ctx.eventBus,
                  "item-data": _ctx.itemData
                }, {
                  default: _withCtx(() => [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _: 3
                }, 8, ["modelValue", "event-bus", "item-data"]))
              : (i.widget)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(i.widget), {
                    key: 3,
                    modelValue: _ctx.internalModel,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.internalModel) = $event)),
                    "item-data": _ctx.itemData
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  }, 8, ["modelValue", "item-data"]))
                : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ], 64))
}